export default __webpack_public_path__ + "static/BWSSC-c15cc1ebc74ec288fd3f93f1e7412ac8.jpg";